import axios from 'axios';
import { getToken } from "../models/auth";

export default axios.create({
    timeout: 30000,
    headers: {
        Authorization: `Bearer ${getToken()}`
    }
})